const titleTemplate = (title: string): string => `${title} - Bibcitation`;

export default titleTemplate;
